export default __webpack_public_path__ + "static/media/holiday_template6.f33abd55.png";